import axiosInstance from "@/api/axiosInstance";
import {
  MoveWaitlistToEnrollmentRequest,
  MoveWaitlistToEnrollmentResponse,
} from "./types";

export const moveWaitlistToEnrollment = async (
  requestData: MoveWaitlistToEnrollmentRequest,
): Promise<MoveWaitlistToEnrollmentResponse> => {
  const url = `/api/private/event-sessions/${requestData.uuid}/waitlist/register`;

  const response = await axiosInstance.post<MoveWaitlistToEnrollmentResponse>(
    url,
    {
      enrollmentId: requestData.enrollmentId,
      sendNotification: requestData.sendNotification ?? true,
      voucherId: requestData.voucherId ?? null,
    },
  );

  return response.data;
};
